import axios from "axios";
import { APIRequestURI } from "../../utils/api_request_uri";
import {
  CREATE_DODO_PAYMENT_URL_FAILED,
  CREATE_DODO_PAYMENT_URL_REQUEST,
  CREATE_DODO_PAYMENT_URL_SUCCESS,
  GET_PAYMENT_INFO_FAILED,
  GET_PAYMENT_INFO_REQUEST,
  GET_PAYMENT_INFO_SUCCESS,
} from "../../constants/Payment/paymentConstants";

export const paymentCreateDodoUrlAction =
  (paymentData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_DODO_PAYMENT_URL_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/payment/dodopayment/newpayment`,
        paymentData,
        config
      );

      dispatch({
        type: CREATE_DODO_PAYMENT_URL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_DODO_PAYMENT_URL_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getPaymentInfoAction =
  (paymentId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_PAYMENT_INFO_REQUEST,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo?.token}`,
        },
      };

      const URI = new APIRequestURI().getBaseURI();
      const { data } = await axios.post(
        `${URI}/api/payment/getpaymentinfo`,
        { paymentId },
        config
      );

      dispatch({
        type: GET_PAYMENT_INFO_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PAYMENT_INFO_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
